import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { timeout } from 'rxjs';
import Swal from 'sweetalert2';

@Injectable({ providedIn: 'root' })
export class ImpressoraService {
  constructor(private httpClient: HttpClient) {}

  public impressoraTicket(valueBase64: string, valueContentType: string) {
    this.conexaoImpressora(valueBase64).catch(error => {
      this.iframeImpressao(valueBase64, valueContentType);
    });
  }

  private iframeImpressao(valueBase64: string, valueContentType: string) {
    const blob = this.convertBase64toBlob(valueBase64, valueContentType);
    const url = URL.createObjectURL(blob);

    this.createIframe(url, 'meuIframe');
  }
  private conexaoImpressora(valueBase64: string): Promise<boolean> {
    const body = {
      Base64: valueBase64
    };

    return new Promise((resolve, reject) => {
      this.httpClient
        .post('http://localhost:4905/ImprimirTicket', body)
        .pipe(timeout(2500))
        .subscribe({
          next() {
            Swal.fire({
              title: 'Sucesso!',
              icon: 'success',
              text: 'Impressão realizada com sucesso.',
              confirmButtonColor: 'green',
              confirmButtonText: 'Ok'
            });
            resolve(true);
          },
          error() {
            reject(false);
          }
        });
    });
  }

  private createIframe(url: string, id: string) {
    const iframe = document.createElement('iframe');
    iframe.src = url;
    iframe.width = '600';
    iframe.height = '400';
    iframe.id = id;
    iframe.style.display = 'none';
    iframe.style.border = 'none';

    document.body.appendChild(iframe);

    this.printIframe(iframe);
  }

  private printIframe(iframe: HTMLIFrameElement): void {
    const iframeWindow = iframe.contentWindow;
    if (iframeWindow) {
      iframeWindow.focus();
      iframeWindow.print();
      iframeWindow.onafterprint = () => {
        document.body.removeChild(iframe);
        URL.revokeObjectURL(iframe.src);
      };
    }
  }

  private convertBase64toBlob(
    valueBase64: string,
    valueContentType: string
  ): Blob {
    const byteCharacters = atob(valueBase64);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      byteArrays.push(new Uint8Array(byteNumbers));
    }
    return new Blob(byteArrays, { type: valueContentType });
  }
}
